import { getAttributeNameWithoutPostfix } from '@/core/shared'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'

export function enablePrevValuesDictionarySupport (contextSelector) {
	$('div.page').on('click', 'button.dictionary-expander', function (e) {
		var $dictionaryList = $(e.target).closest('.attribute').find('.dictionary-list')
		showPrevValuesDictionaryAddForm($dictionaryList)
	})
	$('#dictionary-save-button').bind('click', function () {
		var listSelector = (contextSelector ? contextSelector + ' #' : '#') + $('#dictionary-add-form').data('data-target')
		var $dictionaryList = $(listSelector)
		if ($dictionaryList) {
			var newValue = $('#new-dict-value').val()
			if (!checkInList($dictionaryList, newValue)) {
				var optionContent = '<option class="new-value" value="' + _.escape(newValue) + '">' + newValue + '</option>'
				var $existingValue = $dictionaryList.find('option.new-value')
				if ($existingValue.length > 0) {
					$existingValue.replaceWith(optionContent)
				} else {
					$dictionaryList.children('option').first().after(optionContent)
				}
			}
			$dictionaryList.val(newValue)
			$dictionaryList.data('data-last-value', newValue)
			attributeChangesRegister(getAttributeNameWithoutPostfix($dictionaryList.attr('id')))
		}
		hidePrevValuesDictionaryAddForm()
	})
}

function checkInList (list, value) {
	var check = false
	$(list).children().each(function (ind, val) {
		if ($(val).val() === value) {
			check = true
			return false
		}
	})
	return check
}

function showPrevValuesDictionaryAddForm (dictionaryList) {
	if (dictionaryList) {
		var maxLength = parseInt($(dictionaryList).attr('data-maxlength'))
		var newValueId = 'new-dict-value'
		var dictionaryListWidth = $(dictionaryList).outerWidth()
		if (!_.isNaN(maxLength)) {
			if (maxLength <= 100 && !$('#' + newValueId).is('input')) {
				$('#dictionary-value-area').html('<input id="' + newValueId + '"  type="text" />')
			} else if (maxLength > 100 && !$('#' + newValueId).is('textarea')) {
				$('#dictionary-value-area').html('<textarea id="' + newValueId + '" rows="2"></textarea>')
			}
			$('#' + newValueId).attr('maxlength', maxLength)
		}
		var lastValue = $(dictionaryList).data('data-last-value')
		$('#new-dict-value').val(lastValue && lastValue !== '' ? lastValue : '')
		var $addForm = $('#dictionary-add-form')
		$addForm.data('data-target', $(dictionaryList).attr('id'))
		$addForm.show()
		$($addForm).offset({
			top: $(dictionaryList).offset().top,
			left: $(dictionaryList).offset().left
		})
		$($addForm).css({
			'max-width': dictionaryListWidth,
			'min-width': dictionaryListWidth
		})
		$('#' + newValueId).css({
			'max-width': dictionaryListWidth,
			'min-width': dictionaryListWidth
		})
		$('#' + newValueId).focus()
		$('body').bind('click', hidePrevValuesDictionaryAddForm)
	}
}

function hidePrevValuesDictionaryAddForm (e) {
	if (e) {
		if ($(e.target).closest('#dictionary-add-form').length == 0 && !$(e.target).hasClass('dictionary-expander')) {
			$('#dictionary-add-form').hide()
			$('body').unbind('click', hidePrevValuesDictionaryAddForm)
		}
	} else {
		$('#dictionary-add-form').hide()
		$('body').unbind('click', hidePrevValuesDictionaryAddForm)
	}
}

export function preparePrevValuesDictionaryData (list, data) {
	var $area = $('#' + getAttributeNameWithoutPostfix($(list).attr('id')) + '__area')
	if ($area && $area.hasClass('sl-editor')) {
		var lang = $('#label__' + $(list).attr('id')).attr('value')
		$(list).html($area.find('.lang-' + lang).html())
	}
	if (!checkInList($(list), data)) {
		$(list).children('option').first().after('<option class="new-value" value="' +
			_.escape(data) + '">' + data + '</option>')
		$(list).data('data-last-value', data)
	}
}

export function disablePrevValuesDictionarySupport () {
	$('div.page').off('click', 'button.dictionary-expander')
	$('#dictionary-save-button').unbind('click')
	$('body').unbind('click', hidePrevValuesDictionaryAddForm);
}
